import React from "react";
import { css, StyleException } from "../../theme/styled";
import { zIndex } from "../../theme/zIndex";

type Props = {
  visible: boolean;
  hasTransitionedIn: boolean;
};

export const BackDrop = React.forwardRef<HTMLDivElement | null, Props>(
  (props, ref) => {
    return (
      <div
        ref={ref}
        aria-hidden="true"
        className={css({
          top: "0px",
          left: "0px",
          right: "0px",
          bottom: "0px",
          zIndex: zIndex.modal - 1,
          position: "fixed",
          backgroundColor: StyleException("rgba(0, 0, 0, 0.5)"),
          opacity: props.visible && props.hasTransitionedIn ? "1" : "0",
          transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;",
        })}
      />
    );
  },
);
